export const isDev = !process.env.BACKEND_API?.includes("trylavender.com");
